import { ReactElement } from 'react';

import { SkeletonFill } from '@/components';

// import { useUsersRowsPerPage } from '../store/use-users-pagination-store';

import { SkeletonUsersTableRow } from './SkeletonUsersTableRow';

export const UsersListLoading = (): ReactElement => {
  // const usersRowsPerPage = useUsersRowsPerPage();

  return (
    <SkeletonFill count={9}>
      <SkeletonUsersTableRow />
    </SkeletonFill>
  );
};
